<template>
  <div class="story-section story-images">
    <div
      class="absolute top-0 h-full lg:top-2/3 lg:h-1/3 w-full"
      ref="el"
    ></div>
    <div
      class="sticky h-full lg:h-screen top-0 flex flex-col justify-center p-4 md:p-24 lg:p-32"
    >
      <div class="flex items-center justify-center h-full -mx-2 md:-mx-4">
        <div
          v-for="(image, i) of images"
          :ref="setRef"
          :key="image.key"
          class="h-full px-2 md:px-4"
          :style="{ width: `${100 / images.length}%`, opacity: opacities[i] }"
        >
          <img
            class="w-full h-full object-contain"
            :class="image.position"
            :src="image.transformed.src"
          />
        </div>
      </div>
      <div v-if="caption?.length" class="mt-4 text-center">
        <BlockContent :blocks="caption" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType, ref } from 'vue';
import { getImageAttributes } from '@/sanity';
import { SanityImageObject } from '@sanity/image-url/lib/types/types';

interface ImageObj extends SanityImageObject {
  _key: string;
}

export default defineComponent({
  props: {
    _key: {
      type: String,
      default: '',
    },
    _type: {
      type: String,
      default: '',
    },
    caption: {
      type: Array,
      default: () => [],
    },
    imageArray: {
      type: Array as PropType<Array<ImageObj>>,
      default: () => [],
    },
  },
  setup(props) {
    const el = ref<HTMLElement | null>(null);
    const images = computed(() =>
      props.imageArray.map((image, i, arr) => ({
        key: image._key,
        position:
          arr.length > 1 && i === 0
            ? 'object-right'
            : arr.length > 1 && i === arr.length - 1
            ? 'object-left'
            : 'object-center',
        transformed: getImageAttributes(image),
      }))
    );

    let refs = [] as Array<HTMLElement>;
    const setRef = (ref: HTMLElement) => refs.push(ref);

    const opacities = ref(props.imageArray.map(() => 0));

    const threshold = Array.from(Array(101).keys()).map((i) => i / 100);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          opacities.value.forEach((currentOpacity, i) => {
            const perc = entry.intersectionRatio * opacities.value.length - i;
            const opacity = Math.min(perc, 1);
            if (opacity > currentOpacity) {
              opacities.value[i] = opacity > 0.95 ? 1 : opacity;
            }
          });
        }
      },
      { threshold }
    );

    onMounted(() => {
      if (el.value) {
        observer.observe(el.value);
      }
      // refs.forEach((ref) => {
      //   observer.observe(ref);
      // });
    });

    return { el, images, setRef, opacities };
  },
});
</script>

<style lang="postcss">
.story-section.story-images {
  @apply relative p-0;
  /* height: 75vh; */
  @screen lg {
    height: 150vh;
  }
}
</style>
